export const colors = {
  dataStatusColors : {
    red : {
      hex : "#D2160E",
      rgb : "210, 22, 14"
    },
    yellow : {
      hex : "#D2900E",
      rgb : "210, 144, 14"
    },
    green : {
      hex : "#0ED279",
      rgb : "14, 120, 121"

    }
  },
  buttonColors : {
    activeFill : {
      rgb : "52, 79, 111",
      hex : "#344F6F"
    },
    activeBorder : {
      hex : "#020A28",
      rgb : "2, 10, 40"
    }
  }

}